import { render, staticRenderFns } from "./StepsContainer.vue?vue&type=template&id=a2b4cc12&"
import script from "./StepsContainer.vue?vue&type=script&lang=js&"
export * from "./StepsContainer.vue?vue&type=script&lang=js&"
import style0 from "./StepsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports